import { action, computed, makeAutoObservable } from "mobx";
import {UserVote} from '../types';

export interface UserVoteSet {
  roundName: string;
  votes: UserVote[]
}

export class UserVoteStore {
  private users = new Map<string, Map<string, boolean>>();
  private thisUser = "";

  constructor() {
    makeAutoObservable(this);
  }

  @action
  addUserVotes(voteSets: UserVoteSet[]) {
    for (let set of voteSets) {
      for (let vote of set.votes) {
        this.add(vote.address, vote.has_submitted, set.roundName);
      }
    }
  }

  @action
  add(user: string, voted: boolean, round: string): void {
    let userdict = this.users.get(user) ?? new Map<string, boolean>();
    userdict.set(round, voted);
    this.users.set(user, userdict);
  }

  @action
  setThisUser(address: string) {
    this.thisUser = address;
  }

  @action
  clear() {
    this.users.clear();
  }

  @computed
  getVotes(round: string) {
    let uservotes = [...this.users.entries()].map(function(p1){return [p1[0], p1[1].get(round)]});
    return Array.from(uservotes);
  }

  @computed
  userVoted(round: string): boolean {
    let userdict = this.users.get(this.thisUser) ?? new Map<string, boolean>();
    return userdict.get(round) ?? false;
  }

  @computed
  allUsersVoted(round: string): boolean {
    // count the number of false elements in the map for the given round
    return [...this.users.values()].filter((v) => !v.get(round)).length === 0;
  }

  @computed
  getThisUser() {
    return this.thisUser;
  }
}
